import { connect } from 'react-redux'
import { get } from 'lodash'
import { getServiceCases } from 'features/Cases/Cases.actions'
import showCasesViewModal from '../CasesViewModal'
import CasesTimeline from './CasesTimeline'

const stateToProps = ({ cases }, { serviceId }) => ({
  cases: get(cases, ['serviceCases', serviceId], []).map(caseId => cases.casesById[caseId]),
  loading: get(cases, ['serviceCasesLoading', serviceId], false),
})

const dispatchToProps = {
  getServiceCases,
  showCasesViewModal,
}

export default connect(stateToProps, dispatchToProps)(CasesTimeline)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/CasesTimeline/CasesTimeline.container.js